'use client';

import { ProductNames } from '../../constants/ProductNames';
import classnames from 'classnames';
import clientConfig from '../../client/config';
import layoutStyles from '../Layout/DefaultLayout.module.scss';
import styles from './PageOwnerActions.module.scss';
import { useAuth } from '../Providers/AuthProvider';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';

export const PageOwnerActions: React.FC = () => {
  const isPageOwner = useIsPageOwner();
  const auth = useAuth();

  const { t } = useTranslation();
  const { slug, product, id } = usePage();

  if (!isPageOwner && !auth?.isStaff()) {
    return null;
  }

  function getEditUrl(): string {
    if (product.name === ProductNames.ProxyTeam) {
      return `${clientConfig.justGivingRootUrl}/teams-creation/manage/${id}/edit-team`;
    }

    return `${clientConfig.justGivingRootUrl}/${slug}/admin/edit`;
  }

  return (
    <div className={classnames('bg-color-neutral-300', styles.container)}>
      <div
        className={classnames(layoutStyles.container, styles.pageOwnerActions)}
      >
        <a href={getEditUrl()} className="cp-btn cp-btn-secondary">
          {t('pageOwnerActions.editPage')}
        </a>
      </div>
    </div>
  );
};
